export enum OperationState {
    WaitingToStart = 1,
    InProgress = 2,
    EndedWithSuccess = 4,
    EndedWithError = 8,
    Stopping = 16,
    Stopped = 32
}
